import CashierActionButton, {
  ActionType,
} from '../components/CashierActionButton';

const CashierSaveTicket = () => {
  return (
    <CashierActionButton
      htmlType='submit'
      type={ActionType.SAVE_TICKET}
      onClick={() => undefined}
    />
  );
};

export default CashierSaveTicket;
